import { Button, useTheme } from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from "react-router-dom";

export default function GoBackButton() {
    const navigate = useNavigate();
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    return (
        <Button
            onClick={() => navigate(-1)}
            startIcon={<ArrowBackIosNewIcon sx={{ fontSize: '0.8rem !important' }} />}
            variant="outlined"
            size="small"
            sx={{
                borderColor: isDark ? 'rgba(255,255,255,0.15)' : 'rgba(13,13,26,0.18)',
                color: theme.palette.text.secondary,
                borderRadius: 2,
                px: 2,
                py: 0.75,
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.85rem',
                letterSpacing: 0.3,
                transition: 'all 0.2s ease',
                '&:hover': {
                    borderColor: theme.palette.secondary.main,
                    color: theme.palette.secondary.main,
                    backgroundColor: isDark
                        ? 'rgba(0,209,255,0.06)'
                        : 'rgba(0,153,187,0.06)',
                    transform: 'translateX(-3px)',
                },
            }}
        >
            Voltar
        </Button>
    );
}
